function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { forwardRef, memo, useCallback } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsGripper } from '@deephaven/icons';
import { Tooltip } from '@deephaven/components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SearchItem = /*#__PURE__*/forwardRef(function SearchItem(props, ref) {
  var value = props.value,
    item = props.item,
    onClick = props.onClick,
    onKeyDown = props.onKeyDown,
    handleProps = props.handleProps;
  var handleClick = useCallback(event => {
    onClick(item, event);
  }, [onClick, item]);
  var handleKeyDown = useCallback(event => {
    onKeyDown(item, event);
  }, [onKeyDown, item]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _jsxs("div", _objectSpread(_objectSpread({
      ref: ref,
      className: classNames('tree-item', {
        isSelected: item.selected
      }),
      onClick: handleClick,
      onKeyDownCapture: handleKeyDown,
      "data-index": item.index
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, handleProps), {}, {
      children: [/*#__PURE__*/_jsx("span", {
        title: value,
        className: classNames('column-name'),
        children: value
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Tooltip, {
          children: "Drag to re-order"
        }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: vsGripper
        })]
      })]
    }))
  );
});
var MemoizedSearchItem = /*#__PURE__*/memo(SearchItem);
export default MemoizedSearchItem;
//# sourceMappingURL=SearchItem.js.map